export const IMPORT_STATES = {
  PROCESSING: 'processing',
  PROCESSED: 'processed',
  PARTIALLY_PROCESSED: 'partially_processed',
  FAILED: 'failed',
}
